import OwnerRoom from "./components/owner/room/owner.room";
import { ChatProvider } from "./contexts/chat.context";
import { DashboardProvider } from "./contexts/dashboard.context";
import { PrinterProvider } from "./contexts/printer.context.jsx";
import { ReservationProvider } from "./contexts/reservation.context";
import { OrderProvider } from "./contexts/order.context.jsx";
import React, { lazy, Suspense } from "react";
import { CssBaseline } from "@mui/material";
import ComponentLoader from "./components/customComponents/component.loader";

import { BrowserRouter as Router, Switch } from "react-router-dom";

import VerifyEmail from './components/user/signup/VerifyEmail.jsx';



const FullScreenError = lazy(() => import("./components/customComponents/fullscreen.error"));
const PrivateRoute = lazy(() => import("./components/customComponents/private.route"));
const Route = lazy(() => import("./components/customComponents/route.title"));
const AppBar = lazy(() => import("./components/owner/appBar/owner.app.bar"));
const ConfirmMail = lazy(() => import("./components/owner/confirmMail/owner.confirm.mail"));
const OwnerDashboard = lazy(() => import("./components/owner/dashboard/owner.dashboard"));

const OwnerHome = lazy(() => import("./components/owner/home/owner.home.jsx"));

const OwnerReport = lazy(() => import("./components/owner/report/owner.report"));
const OwnerFidelity = lazy(() => import("./components/owner/fidelity/OwnerFidelity.jsx"))

const OwnerMenu = lazy(() => import("./components/owner/menu/owner.menu"));
const OwnerHistoryOrder = lazy(() => import("./components/owner/historyOrder/OwnerHistoryOrder.jsx"));
const OwnerProfile = lazy(() => import("./components/owner/profile/owner.profile"));
const OwnerSignup = lazy(() => import("./components/owner/signup/owner.signup"));
const OwnerTables = lazy(() => import("./components/owner/tables/owner.tables"));
const OwnerDelivery = lazy(() => import("./components/owner/delivery/delivery.jsx"));
const OwnerChat = lazy(() => import("./components/owner/chat/chat.jsx"));

const ResetPassword = lazy(() => import("./components/restorePassword/restore.password"));

const Landing = lazy(() => import("./landing/landing.jsx"));
const UserProfile = lazy(() => import("./components/user/profile/userProfile.jsx"));
const UserProfilePersonalData = lazy(() => import("./components/user/profile/UserProfilePersonalData.jsx"))
const UserAddress = lazy(() => import("./components/user/profile/userAddress.jsx"))
const UserHistoryOrder = lazy(() => import("./components/user/profile/userHistoryOrder.jsx"))
const UserSecurity = lazy(() => import("./components/user/profile/UserSecurity.jsx"))
const ScanQRCodeAlert = lazy(() => import("./components/customComponents/ScanQRCodeAlert.jsx"));
const UserFidelityList = lazy(() => import("./components/user/profile/userFidelityList.jsx"));

const Terms = lazy(() => import("./landing/terms"));
const Privacy = lazy(() => import("./landing/privacy"));
const UserSignup = lazy(() => import("./components/user/signup/user.signup"));
const UserBottomNavigation = lazy(() => import("./components/user/bottomNavigation/user.bottom.navigation"));
const UserBottomNavigationDelivery = lazy(() => import("./components/user/bottomNavigation/user.bottom.navigationDelivery"));
const SignIn = lazy(() => import("./components/signin"));
const RestorePassword = lazy(() => import("./components/restorePassword/restore.password.request"));


const SuccessPaymentDelivery = lazy(() => import("./components/customComponents/success.payment.jsx"));

export default function AppContent() {

    return (
        <>
            <Suspense fallback={<ComponentLoader />}>
                <CssBaseline />
                <Router>

                    <Switch>
                        <Route exact path="/">
                            <Landing />
                        </Route>
                        <Route exact path="/privacy" title="Informativa privacy">
                            <Privacy />
                        </Route>
                        <Route exact path="/terms" title="Termini e condizioni">
                            <Terms />
                        </Route>
                        <Route exact path="/signin" title="Accedi">
                            <SignIn />
                        </Route>

                        <Route exact path="/user/table/qrcode">
                            <ScanQRCodeAlert />
                        </Route>

                        {/* ********************* INIZIO LATO USER *****************/}
                        <Route exact path="/user/signup" title="Registrati">
                            <UserSignup />
                        </Route>
                        <Route exact path="/user/verify-email/:token" title="Verifica e-mail">
                            <VerifyEmail />
                        </Route>

                        <Route
                            exact
                            path="/user/restorePassword/:requestId/:userId"
                            title="Recupero password"
                        >
                            <ResetPassword />
                        </Route>
                        <Route exact path="/user/restorePassword" title="Recupero password">
                            <RestorePassword />
                        </Route>
                        {/* <PrivateRoute exact path="/user/home">
                            <Landing logged={true} />
                        </PrivateRoute> */}

                        <PrivateRoute exact path="/user/profile">
                            <UserProfile />
                        </PrivateRoute>
                        <PrivateRoute exact path="/user/personalData">
                            <UserProfilePersonalData />
                        </PrivateRoute>
                        <PrivateRoute exact path="/user/address">
                            <UserAddress />
                        </PrivateRoute>
                        <PrivateRoute exact path="/user/historyOrder">
                            <UserHistoryOrder />
                        </PrivateRoute>
                        <PrivateRoute exact path="/user/fidelityCard">
                            <UserFidelityList />
                        </PrivateRoute>
                        <PrivateRoute exact path="/user/security">
                            <UserSecurity />
                        </PrivateRoute>




                        <PrivateRoute
                            exact
                            path="/user/reservation/:ownerId/:tableId"
                            title="Ordina"
                        >
                            <PrinterProvider>
                                <ReservationProvider>
                                    <ChatProvider>
                                        <OrderProvider>
                                            <UserBottomNavigation section={0} />
                                        </OrderProvider>
                                    </ChatProvider>
                                </ReservationProvider>
                            </PrinterProvider>
                        </PrivateRoute>
                        <PrivateRoute
                            exact
                            path="/user/history/:ownerId/:tableId"
                            title="Ordina"
                        >
                            <PrinterProvider>
                                <ReservationProvider>
                                    <ChatProvider>
                                        <OrderProvider>
                                            <UserBottomNavigation section={1} />
                                        </OrderProvider>
                                    </ChatProvider>
                                </ReservationProvider>
                            </PrinterProvider>
                        </PrivateRoute>
                        <PrivateRoute
                            exact
                            path="/user/chat/:ownerId/:tableId"
                            title="Chat"
                        >
                            <PrinterProvider>
                                <ReservationProvider>
                                    <ChatProvider>
                                        <OrderProvider>
                                            <UserBottomNavigation section={2} />
                                        </OrderProvider>
                                    </ChatProvider>
                                </ReservationProvider>
                            </PrinterProvider>
                        </PrivateRoute>
                        <PrivateRoute
                            exact
                            path="/user/cart/:ownerId/:tableId"
                            title="Ordina"
                        >
                            <PrinterProvider>
                                <ReservationProvider>
                                    <ChatProvider>
                                        <OrderProvider>
                                            <UserBottomNavigation section={3} />
                                        </OrderProvider>
                                    </ChatProvider>
                                </ReservationProvider>
                            </PrinterProvider>
                        </PrivateRoute>

                        <PrivateRoute
                            exact
                            path="/user/profile/:ownerId/:tableId"
                            title="Profilo"
                        >
                            <PrinterProvider>
                                <ReservationProvider>
                                    <ChatProvider>
                                        <OrderProvider>
                                            <UserBottomNavigation section={4} />
                                        </OrderProvider>
                                    </ChatProvider>
                                </ReservationProvider>
                            </PrinterProvider>
                        </PrivateRoute>


                        <PrivateRoute
                            exact
                            path="/user/delivery/:ownerId"
                            title="Ordina"
                        >
                            <PrinterProvider>
                                <ReservationProvider>
                                    <UserBottomNavigationDelivery section={0} />
                                </ReservationProvider>
                            </PrinterProvider>
                        </PrivateRoute>

                        <PrivateRoute
                            exact
                            path="/user/deliverySuccessPayment/:ownerId"
                            title="Ordina"
                        >
                            <PrinterProvider>
                                <ReservationProvider>
                                    <SuccessPaymentDelivery />
                                </ReservationProvider>
                            </PrinterProvider>
                        </PrivateRoute>

                        <PrivateRoute
                            exact
                            path="/user/deliverycart/:ownerId"
                            title="Ordina"
                        >
                            <PrinterProvider>
                                <ReservationProvider>
                                    <UserBottomNavigationDelivery section={1} />
                                </ReservationProvider>
                            </PrinterProvider>
                        </PrivateRoute>
                        <PrivateRoute
                            exact
                            path="/user/profile/:ownerId"
                            title="Ordina"
                        >
                            <PrinterProvider>
                                <ReservationProvider>
                                    <UserBottomNavigationDelivery section={2} />
                                </ReservationProvider>
                            </PrinterProvider>
                        </PrivateRoute>
                        {/* ********************* FINE LATO USER *****************/}


                        {/* ********************* INIZIO RECUPERO PASSWORD E REGISTAZIONE *****************/}
                        <Route exact path="/owner/signup" title="Registrati">
                            <OwnerSignup />
                        </Route>
                        <Route
                            exact
                            path="/owner/restorePassword/:requestId/:userId"
                            title="Recupero password"
                        >
                            <ResetPassword />
                        </Route>
                        <Route
                            exact
                            path="/owner/restorePassword"
                            title="Recupero password"
                        >
                            <RestorePassword />
                        </Route>
                        <Route
                            exact
                            path="/owner/confirmEmail/:token"
                            title="Conferma e-mail"
                        >
                            <ConfirmMail />
                        </Route>
                        {/* ********************* FINE RECUPERO PASSWORD E REGISTAZIONE *****************/}

                        {/* ********************* LATO OWNER *****************/}
                        <PrivateRoute exact path="/owner/profile" title="Profilo">
                            <AppBar>
                                <OwnerProfile />
                            </AppBar>
                        </PrivateRoute>
                        <PrivateRoute exact path="/owner/menu" title="Menu">
                            <AppBar>
                                <OwnerMenu />
                            </AppBar>
                        </PrivateRoute>
                        <PrivateRoute exact path="/owner/history" title="Storico Ordini">
                            <AppBar>
                                <OwnerHistoryOrder />
                            </AppBar>
                        </PrivateRoute>

                        <PrivateRoute exact path="/owner/tables" title="Tavoli">
                            <AppBar>
                                <OwnerTables />
                            </AppBar>
                        </PrivateRoute>

                        <PrivateRoute exact path="/owner/room" title="Sala">
                            <PrinterProvider>
                                <DashboardProvider>
                                    <ReservationProvider>
                                        <AppBar>
                                            <OwnerRoom />
                                        </AppBar>
                                    </ReservationProvider>
                                </DashboardProvider>
                            </PrinterProvider>
                        </PrivateRoute>

                        <PrivateRoute exact path="/owner/delivery" title="Delivery">
                            <PrinterProvider>
                                <DashboardProvider>
                                    <ReservationProvider>
                                        <AppBar>
                                            <OwnerDelivery />
                                        </AppBar>
                                    </ReservationProvider>
                                </DashboardProvider>
                            </PrinterProvider>
                        </PrivateRoute>

                        <PrivateRoute exact path="/owner/chat" title="Chat">
                            <PrinterProvider>
                                <ChatProvider>
                                    <DashboardProvider>
                                        <ReservationProvider>
                                            <AppBar>
                                                <OwnerChat />
                                            </AppBar>
                                        </ReservationProvider>
                                    </DashboardProvider>
                                </ChatProvider>
                            </PrinterProvider>
                        </PrivateRoute>

                        <PrivateRoute exact path="/owner/dashboard" title="Dashboard">
                            <PrinterProvider>
                                <DashboardProvider >
                                    <AppBar>
                                        <OwnerDashboard />
                                    </AppBar>
                                </DashboardProvider>
                            </PrinterProvider>
                        </PrivateRoute>

                        <PrivateRoute exact path="/owner/home" title="Home">
                            <AppBar>
                                <OwnerHome />
                            </AppBar>
                        </PrivateRoute>

                        <PrivateRoute exact path="/owner/report" title="Report">
                            <PrinterProvider>
                                <DashboardProvider>
                                    <AppBar>
                                        <OwnerReport />
                                    </AppBar>
                                </DashboardProvider>
                            </PrinterProvider>
                        </PrivateRoute>

                        <PrivateRoute exact path="/owner/fidelity" title="Programma fedeltà">
                            <PrinterProvider>
                                <DashboardProvider>
                                    <AppBar>
                                        <OwnerFidelity />
                                    </AppBar>
                                </DashboardProvider>
                            </PrinterProvider>
                        </PrivateRoute>

                        {/* <PrivateRoute
                        exact
                        path="/owner/reservation/:ownerId"
                        title="Ordina"
                    >
                        <ReservationProvider>
                            <AppBar>
                                <OwnerReservation />
                            </AppBar>
                        </ReservationProvider>
                    </PrivateRoute>
                    <PrivateRoute
                        exact
                        path="/owner/reservation/:ownerId/:tableId"
                        title="Ordina"
                    >
                        <ReservationProvider>
                            <AppBar>
                                <OwnerReservation />
                            </AppBar>
                        </ReservationProvider>
                    </PrivateRoute> */}
                        {/* ********************* FINE OWNER *****************/}








                        {/* ********************* ERROR 404 *****************/}
                        <Route path="*">
                            <FullScreenError name="404" text="Pagina non trovata" />
                        </Route>




                    </Switch>
                </Router>
            </Suspense>
        </>
    );
};

